import React from 'react';
import { Backdrop } from '@mui/material';
import { Box, BoxProps } from '../box';
import { useTheme } from '../../hooks/useTheme';

interface Props extends BoxProps {
  isActive: boolean;
  onClose?: () => void;
}

/**
 * @description This component should be used in cases when SEO requirements says
 * that modal content should be present in html code before the modal opening and
 * after it closed
 */
export const ModalWithConstantPresence: React.FC<React.PropsWithChildren<Props>> = ({ isActive, onClose, children, ...props }) => {
  const theme = useTheme();
  return (
    <Box
      sx={[
        {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          position: 'fixed',
          zIndex: 50,
          overflow: 'auto',
          visibility: isActive ? 'visible' : 'hidden',
          opacity: isActive ? 1 : 0,
          transition: theme.transitions.create(['opacity'], {
            duration: theme.transitions.duration.standard,
          }),
          // borderRadius: `${theme.borderRadius.extraLarge}px`,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          // maxHeight: '90%',
          // maxWidth: '90%',
        },
        {
          // maxHeight: '90vh',
          // maxWidth: '90vw',
        },
      ]}
      {...props}
    >
      <Backdrop onClick={onClose} open={isActive} />
      {children}
    </Box>
  );
};
